const DominatorStacking = {
    DOMINATOR_STACKING_SET_IS_USED: 'DOMINATOR_STACKING_SET_IS_USED',
    DOMINATOR_STACKING_ADD_ITEM: 'DOMINATOR_STACKING_ADD_ITEM',
    DOMINATOR_STACKING_REMOVE_ITEM: 'DOMINATOR_STACKING_REMOVE_ITEM',
};

export default DominatorStacking;
